import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setupI18n } from '@toki/i18n';

import '@toki/theme/tokens.css';
import './admin-tokens.css';
import './app.css';

import { App } from './App';

/* ⚠️ AQUÍ NO SE ESCRIBE NINGÚN COLOR. La paleta del admin vive entera en
 * `admin-tokens.css` y no se re-declara en ningún otro sitio.
 *
 * Hasta el 2026-09-25 este fichero llamaba a `applyBrand(deriveBrand(...))`
 * y acto seguido pisaba cinco variables con `setProperty` sobre `:root`. Eso
 * es **estilo inline**, así que ganaba a la hoja de estilos: era una TERCERA
 * copia de la paleta de acción, escrita en un `.tsx`, donde no la encuentra
 * nadie que busque colores en los `.css`. El paso 36 cambió la paleta entera
 * y estos cinco `setProperty` siguieron sirviendo el azul viejo `#002F73` a
 * toda la aplicación — sin que nada fallara.
 *
 * `applyBrand` existe para que un tenant tiña la app, y el admin **no hereda
 * el sistema visual del tenant**: tiene el suyo. Lo que el tenant sí aporta
 * es su MARCA (las imágenes y el `logoAlt`), y eso se lee de `tenantConfig`
 * allí donde se usa, en `App.tsx`. No hace falta tocar `:root` para nada.
 *
 * Si algún día el admin tiene que teñirse por tenant, la vía NO es volver a
 * `setProperty`: es que `admin-tokens.css` lea una variable y que el tenant
 * la defina en un sitio, no en dos. */

setupI18n('es');

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
